import { render, staticRenderFns } from "./MemberGmc.vue?vue&type=template&id=e18a6242"
import script from "./MemberGmc.vue?vue&type=script&lang=js"
export * from "./MemberGmc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports